import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import MaskedReveal from "./MaskedReveal";

export default function FinalCTA({ settings }) {
  const title = settings?.final_cta_title || "Let's create something worth remembering.";
  return (
    <section
      data-testid="final-cta"
      className="bg-ivory text-ink py-28 md:py-48 relative overflow-hidden"
    >
      <div className="mx-auto px-6 md:px-12 lg:px-16">
        <p className="label-mono opacity-60 line-badge">05 — Next chapter</p>
        <MaskedReveal
          as="h2"
          lines={title.split(" ").reduce((rows, word, i, arr) => {
            const third = Math.ceil(arr.length / 3);
            const idx = Math.min(2, Math.floor(i / third));
            rows[idx] = (rows[idx] || "") + (rows[idx] ? " " : "") + word;
            return rows;
          }, [])}
          className="mt-8 font-editorial text-6xl md:text-8xl lg:text-9xl leading-[0.92] max-w-6xl"
          onDark={false}
        />
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6, duration: 0.8 }}
          className="mt-14 flex flex-wrap gap-4"
        >
          <Link to="/booking" className="btn-outline-ink" data-testid="final-cta-book">
            Check Availability
          </Link>
          <Link to="/contact" className="btn-outline-ink" data-testid="final-cta-contact">
            Contact Oereshaus
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
